import React from 'react';
import PropTypes from 'prop-types';
import BasketProductGroup from './basket-product-group';

export default class BasketGroups extends React.Component {
    render() {
        return (
            <div className="basket__groups">
                {this.props.productGroups.map((productGroup) =>
                    <div key={productGroup.id} className="basket__group">
                        <BasketProductGroup productGroup={productGroup}
                            onUpdateProductQuantity={this.props.onUpdateProductQuantity}
                            hasBallotConfiguration={this.props.hasBallotConfiguration}/>
                    </div>)}
            </div>
        );
    }
}

BasketGroups.propTypes = {
    productGroups: PropTypes.array.isRequired,
    onUpdateProductQuantity: PropTypes.func.isRequired,
    hasBallotConfiguration : PropTypes.bool
};
